import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTicklessParkinginline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M39 52H17V40.613C17 37.538 18.666 36 21.999 36H54c3.334 0 5 1.538 5 4.613V52H39z",
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M25 46a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm26 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z",
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("path", { d: "M21 36c.642-1.407 1.642-3.74 3-7 2.037-4.89 2.5-6 7-6h14c4.5 0 4.963 1.11 7 6 1.358 3.26 2.358 5.593 3 7" }),
			/* @__PURE__ */ _jsx("path", {
				d: "M23 52v6m30-6v6M8.5 24a3.5 3.5 0 0 1 3.5 3.5V58H5V27.5A3.5 3.5 0 0 1 8.5 24z",
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("path", { d: "M10 24.5L54 8M5 32l7-3M5 39l7-3M5 46l7-3M5 53l7-3" })
		]
	})
});
export default SvgTicklessParkinginline;
